'use strict';

var React = require('react');
var framerMotion = require('framer-motion');
var styleInject_es = require('./style-inject.es-9d2f5f4e.js');
var Text = require('./Text-e7ed0974.js');
var Icon = require('./Icon-405a216c.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css_248z = ".sc-bFJieXBA- {\n  margin-top: calc(16px / 4);\n  margin-top: var(--space-smaller);\n}\n\n.xybhC5Y6mk4- {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: calc(16px / 4);\n  padding: var(--space-smaller);\n  padding-left: 0;\n}\n\n.xybhC5Y6mk4- > svg {\n  margin-right: calc(16px / 4);\n  margin-right: var(--space-smaller);\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n\n.xybhC5Y6mk4-:focus {\n  box-shadow: 0px 0px calc(16px / 4) calc(16px / 8)\n    rgb(231, 213, 87);\n  box-shadow: var(--shadow-focus);\n  outline: none;\n}\n";
var styles = {"hasValidationMessage":"sc-bFJieXBA-","message":"xybhC5Y6mk4-"};
styleInject_es.styleInject(css_248z);

function InputValidation({ message }) {
    const messages = [message];
    const variants = {
        slideOut: { y: "5%", opacity: 0 },
        slideIn: { y: 0, opacity: 1 },
    };
    return (React__default["default"].createElement(React__default["default"].Fragment, null, messages && messages.length > 0 && (React__default["default"].createElement(framerMotion.AnimatePresence, { exitBeforeEnter: true }, messages.map(msg => (React__default["default"].createElement(framerMotion.motion.div, { key: `validation-${msg}`, variants: variants, initial: "slideOut", animate: "slideIn", exit: "slideOut", transition: { duration: 0.2 } },
        React__default["default"].createElement("div", { className: styles.message, "aria-live": "assertive", role: "alert", tabIndex: 0 },
            React__default["default"].createElement(Icon.Icon, { name: "alert", size: "small", color: "critical" }),
            React__default["default"].createElement(Text.Text, { size: "small", variation: "error" }, msg)))))))));
}

exports.InputValidation = InputValidation;
